export default __webpack_public_path__ + "static/media/uxui.ed79048c.png";